import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How long does it take to complete app projects?",
    answer: `<p>The timeline of a mobile app development project can vary according to the scale and complexity level of the project. However, a simple application with limited modules usually takes 2-4 months. On the other hand, the application with diverse functionalities and scalable user interfaces takes at least 8-10 months and the period can be extended further.</p>`,
  },
  {
    question: " How much does it cost to build an app?",
    answer: ` <p>The cost of developing an app is influenced by numerous factors, but the primary consideration is the app's complexity. Assuming a development rate of $40 per hour, a basic app may range from $40,000 to $60,000 in development costs. An average app, with more features and functionality, could cost anywhere from $60,000 to $150,000. On the other hand, if you're developing a highly intricate app with advanced features, the development cost for such a project may begin at $300,000.</p>`,
  },
  {
    question:
      " Why should we hire you as our app development company in Dallas?",
    answer: `<p>Considering the transformation of business digitization from the web to app, it has become a need of every brand to build a mobile application for connecting with the audience in a reliable manner. It not only helps you scale the business across the market but also ensures sustainability for competing in your relevant industry.</p>`,
  },
  {
    question: "Where are you located in Dallas?",
    answer: `<p>We are located at “5301 Alpha Rd Suite 80 - 11, Dallas, TX 75240”.</p>`,
  },
  {
    question:
      "Does TekRevol offer NDAs for mobile app development projects in Dallas?",
    answer: `<p>Yes, TekRevol provides Non-Disclosure Agreements (NDAs) to safeguard the confidentiality and security of your sensitive information during the mobile app development services in Dallas.</p>`,
  },
  {
    question:
      "How to find a reliable mobile app development company near me in Dallas?",
    answer: `<p>To find a reliable mobile app development company in Dallas, start by researching online directories, reading reviews, and asking for recommendations from your professional network. Narrow down your options based on their portfolio, experience, expertise in your industry, and proximity to your location. Schedule consultations with potential companies to discuss your project requirements and assess their capabilities.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
